import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useQuery } from "react-query";

export function useWorkorderWithAssignmentById(workOrderId?: number | string) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["workOrderWithAssignmentById", workOrderId],
    queryFn: async () => {
      if (workOrderId) return await apiContext.workOrderApis.getWorkOrderWithAssignment(workOrderId);
    },
  });
}
